import carouselSlider, { CarouselSliderVariantsType, carouselSliderVariants } from './carousel-slider';

const hero = {
  carouselSlider
};

export interface HeroType {
  /** The Carousel Slider variants type. */
  CarouselSlider: CarouselSliderVariantsType;
}

export const heroVariants = {
  carouselSlider: carouselSliderVariants
};

export default hero;
